import { render, staticRenderFns } from "./PollingChannel.vue?vue&type=template&id=0811e9dd&"
import script from "./PollingChannel.vue?vue&type=script&lang=js&"
export * from "./PollingChannel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/project/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0811e9dd')) {
      api.createRecord('0811e9dd', component.options)
    } else {
      api.reload('0811e9dd', component.options)
    }
    module.hot.accept("./PollingChannel.vue?vue&type=template&id=0811e9dd&", function () {
      api.rerender('0811e9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/PollingChannel.vue"
export default component.exports